import { useState } from 'react';
import './Pricing.css';
import { useRevit } from '../../contexts/RevitContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { SignOutButton, useUser } from '@clerk/clerk-react';
import Icon from '../Icon';

const PricingVip = () => {
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const { username, userEmail } = useRevit();
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useUser();

    const handlePlanSelection = (planType) => {
        createCheckoutSession(planType);
    }

    const createCheckoutSession = async (planType) => {
        setIsLoading(true);
        try {
            const response = await fetch(`https://${SERVER_URL}/api/create-checkout-session`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    userId: username, 
                    planType: planType, 
                    email: userEmail 
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to create checkout session');
            }

            const { url } = await response.json();
            window.location.href = url;
        } catch (error) {
            console.error('Error creating checkout session:', error);
            setIsLoading(false);
        }
    };


    return (
        <div className="pricing-container">
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-text">Loading checkout...</div>
                </div>
            )}
            <h1>It seems your plan has expired.</h1>
            <p className="pricing-text">Think this is a mistake? You have <b>almost certainly logged in with the wrong email.</b> Please see the currently logged in email in the bottom left and double & quadruple check that it is the correct one.</p>

            <p className="pricing-text">By subscribing to RevTrack, you agree to our <a href="https://getrevtrack.com/terms-conditions/" target="_blank" rel="noreferrer" style={{ color: 'white', fontWeight: 'bold', textDecoration: 'underline' }}>Terms of Service</a>. Cancel anytime.</p>

            <div className="pricing-options">
                <div className="pricing-card highlight">
                    <h2>RevTrack</h2>
                    <div className="price">
                        <span className="currency">$</span>
                        <span className="amount">3000</span>
                        <span className="period">Yearly</span>
                    </div>
                    <button className="continue-button" onClick={() => handlePlanSelection('vip')}>Continue Tracking</button>
                </div>
            </div>

            <div className="unsupported-notice">
                <p>
                    Note: we currently cannot support tracking for the following softwares. 
                    If you only use one of these, do not buy RevTrack as it won't work for you:
                </p>
                <div className="unsupported-list">
                    <div>
                        <FontAwesomeIcon icon={faTimes} className="unsupported-icon" />
                        Podia
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faTimes} className="unsupported-icon" />
                        Skool
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faTimes} className="unsupported-icon" />
                        Shopify
                    </div>
                </div>
            </div>
            
            <div className="loading-user-section">
                <div className="loading-user-info">
                    <span className="loading-user-email">{user?.primaryEmailAddress?.emailAddress}</span>
                    <SignOutButton>
                        <Icon name="logout" size={20} color="white" style={{ cursor: 'pointer' }} />
                    </SignOutButton>
                </div>
            </div>
        </div>
    );
};

export default PricingVip;
